<template>
    <div>
        <div class="title">
            <h3 class="left">Informations du contrat</h3>
        </div>
        <div class="general-lists">
            <div class="table-responsive">
                <div id="basicTable_wrapper" class="dataTables_wrapper form-inline no-footer">
                    <table id="basicTable" role="grid" class="table table-hover dataTable no-footer">
                        <tbody>
                            <tr>
                                <td class="v-align-middle"><span>Statut</span></td>
                                <td class="v-align-middle"><span>{{ contract.decoded_status }}</span></td>
                            </tr>
                            <tr>
                                <td class="v-align-middle"><span>Date de création</span></td>
                                <td class="v-align-middle"><span>{{contract.created_at | moment-date }}</span></td>
                            </tr>
                            <tr>
                                <td class="v-align-middle"><span>Date de début de contrat </span></td>
                                <td class="v-align-middle"><span>{{contract.start_date | moment-date }}</span></td>
                            </tr>
                            <tr>
                                <td class="v-align-middle"><span>Canal d'entrée</span></td>
                                <td class="v-align-middle"><span>Agence</span></td>
                            </tr>
                            <!-- <tr>
                                <td class="v-align-middle"><span>Crée par</span></td>
                                <td class="v-align-middle"><span>Juliette Roméo - Agence Opéra</span></td>
                            </tr> -->
                            <!-- <tr>
                                <td class="v-align-middle"><span>Coût total mensuel</span></td>
                                <td class="v-align-middle"><span>30€</span></td>
                            </tr>
                            <tr>
                                <td class="v-align-middle"><span>Dépôt de garantie</span></td>
                                <td class="v-align-middle"><span>100€</span>
                                </td>
                            </tr> -->
                            <tr v-if="contract.end_date">
                                <td class="v-align-middle"><span>Date de sortie</span></td>
                                <td class="v-align-middle"><span>{{contract.end_date | moment-date}}</span>
                                </td>
                            </tr>
                            <!-- <tr>
                                <td class="v-align-middle"><span>Apporteur d'affaires</span></td>
                                <td class="v-align-middle"><span>Ouais gros !</span></td>
                            </tr> -->
                            <tr v-if="contract.order && contract.order.sap_promo_code">
                                <td class="v-align-middle"><span>Code promo</span></td>
                                <td class="v-align-middle"><span>{{ contract.order.sap_promo_code }}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script type="text/babel">
    export default {

      props: ["contract"],

    }
</script>



// WEBPACK FOOTER //
// client/components/Customer/ContractManagementContent/Domiciliation/ContractInformations.vue